import { Alert, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

export interface SentRequestConfirmationProps {
  transfereeName: string;
}

export function SentRequestConfirmation(props: SentRequestConfirmationProps) {
  const { transfereeName } = props;
  return (
    <Stack alignItems="center" spacing={7}>
      <Text variant="body1">
        Your transfer request will expire in 5 minutes. We&apos;ll keep you updated on its status.
      </Text>
      <Alert severity="info" variant="filled">
        You&apos;ll receive a notification when {transfereeName} responds to your transfer request.
      </Alert>
    </Stack>
  );
}
